import React, { useState, useEffect } from "react";  // Make sure to include useEffect
import {RadioButtonInput } from '../../components/FormInitiators';
import DynamicTable2 from "../../components/DynamicTable2";


const PensionForm5 = ({ formData, setFormData, onFormDataChange, onBack, onNext }) => {
  

  const handleInputChange = ({ target: { name, value } }) => {
    onFormDataChange({ [name]: value });
  };

  const onTableDataChange = (key) => (rows) => {
    setFormData((prevState) => {
      return { ...prevState, [key]: rows };
    });
  };

  return (
  <div className="google_forms">
      <div className="forms">
    <form className="seventh-pay-arrears-form">
    <h3>Office Details</h3>

        <label>
        Non qualify service Years:
        <input type="text" name="nonQualifyServiceYears" value={formData.nonQualifyServiceYears} onChange={handleInputChange} />
        </label>

        <label>
        Non Qualify Service Months:
        <input type="text" name="nonQualifyServiceMonths" value={formData.nonQualifyServiceMonths} onChange={handleInputChange} />
        </label>

        <label>
        Non Qualify Service Days
        <input type="text" name="nonQualifyServiceDays" value={formData.nonQualifyServiceDays} onChange={handleInputChange} />
        </label>

      {/* Navigation Buttons */}
      <div className="seventh-pay-arrears-buttons-container">
        <button type="button" onClick={onBack}>Back</button>
        <button type="button" onClick={onNext}>
         Next
        </button>
      </div>
    </form>
    </div>
    </div>
  );
};

export default PensionForm5;
